import OurService from './routes/content/OurService.vue';
import createOurService from './routes/content/component/createOurService.vue';
import editOurService from './routes/content/component/editOurService.vue';

import editBannerOurService from './routes/banner/Banner.vue';

const ourServiceRoutes = [
      
        {
            path: '/our-service',
            name: 'OurService',
            component: OurService,
        },
        {
            path: '/create-our-service',
            name: 'createOurService',
            component: createOurService,
        },
        {
            path: '/edit-our-service/:id',
            name: 'editOurService',
            component: editOurService,
        },
        {
            path: '/banner-our-service',
            name: 'editBannerOurService',
            component: editBannerOurService,
        },
];

export default ourServiceRoutes;
